import React from 'react';
import { CtaButton } from './CtaButton';
import { TopoLines } from './TopoLines';
import { ProductStack } from './ProductStack';
const chips = ['6 Volumes', '161 Bench Cards', '31 Shop Worksheets', '5 Bonuses', '2- & 4-Stroke'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Works alongside your OEM service manuals'];

// Los colores de las 4 Gates + el flujo de retiro
const gates = ['bg-patrol-mustard', 'bg-ember', 'bg-sky', 'bg-moss', 'bg-signal'];
export function Hero() {
  return <section className="topo-dark relative w-full overflow-hidden border-b-4 border-ember bg-forest-deep" data-id="element-118" data-mp="xb5r1d2hkpv7">
      <TopoLines className="pointer-events-none absolute -right-24 -top-12 h-[360px] w-[360px] text-paper/[0.07] sm:h-[460px] sm:w-[460px]" data-id="element-119" data-mp="sde0onhhpbt4" />

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-12" data-id="element-120" data-mp="3d21uq4bdkwqw">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-121" data-mp="381xmf1kmf8br">
          <div data-id="element-122" data-mp="3j8sd1u7lx7mo">
            <p className="eyebrow text-ember" data-id="element-123" data-mp="3j7zcjaz8recz">
              For small engine &amp; outdoor power equipment techs
            </p>
            <h1 className="mt-3 font-display text-[40px] uppercase leading-[0.98] text-paper sm:text-6xl md:text-7xl" data-id="element-124" data-mp="3o73na61tdk5f">
              Cleaned the carb three times.{' '}
              <span className="text-ember" data-id="element-125" data-mp="3e8mtl1bhqrfo">Still surging?</span>
            </h1>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-paper/80 sm:text-lg" data-id="element-126" data-mp="30iaziwvciilw">
              Small Engine Diagnostic Pro gives you 161 Bench Cards that run
              every fault through the same 4 Gates — safety &amp; electrical,
              spark, fuel &amp; air, compression — cheapest test first, with a
              PASS/FAIL checkpoint at every step. Then it sends the job out with
              the repair order, estimate and pickup notice already done.{' '}
              <span className="font-semibold text-paper" data-id="element-127" data-mp="2hljas7x1bbag">
                For mowers, riders, zero-turns, handhelds, snow blowers,
                generators and more.
              </span>
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-128" data-mp="nbbeh30z0j7e">
              {chips.map(chip => <li key={chip} className="rounded-md border border-paper/25 bg-paper/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-paper/90" data-id="element-129" data-mp="ic86b9pp1wv7">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductStack data-id="element-130" data-mp="1622hznya1fdv" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-131" data-mp="16345wt0e5wd0">
          <div className="w-full max-w-md" data-id="element-132" data-mp="112g55fmd215l">
            <CtaButton data-id="element-133" data-mp="111eqz2a1syjn">Get Small Engine Diagnostic Pro</CtaButton>
          </div>

          <div className="mt-5 flex max-w-md flex-col items-center gap-2.5 text-center sm:flex-row sm:text-left" data-id="element-134" data-mp="x02zssbj059c">
            <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-135" data-mp="3ltqclcptivti">
              {gates.map(color => <li key={color} className={`h-7 w-7 rounded-full border-2 border-forest-deep ${color}`} data-id="element-136" data-mp="3hpsf16g55t2k" />)}
            </ul>
            <p className="text-[13px] leading-snug text-paper/70" data-id="element-137" data-mp="21bpohm48634d">
              Built for independent shops, mobile techs and garage repairers —
              in the US, UK, Canada and Australia.
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-138" data-mp="2b2soeklf4c22">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-139" data-mp="2kydtirls9sg1">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-140" data-mp="2l0q9iz7zdsqg" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}